/* =============================================
   IRONCLAD CUSTOMS — THEME.JS
   ============================================= */

document.addEventListener('DOMContentLoaded', function () {

  /* cursor: default browser */

  /* ---- SCROLL REVEAL ---- */
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(e => { if (e.isIntersecting) e.target.classList.add('visible'); });
  }, { threshold: 0.12 });
  document.querySelectorAll('.fade-up').forEach(el => observer.observe(el));

  /* ---- MOBILE MENU ---- */
  const mobileToggle = document.getElementById('mobile-menu-toggle');
  const mobileMenu   = document.getElementById('mobile-menu');
  if (mobileToggle && mobileMenu) {
    mobileToggle.addEventListener('click', () => {
      const isOpen = mobileMenu.classList.toggle('open');
      mobileMenu.setAttribute('aria-hidden', !isOpen);
      mobileToggle.setAttribute('aria-expanded', isOpen);
    });
  }

  /* ---- SEARCH TOGGLE ---- */
  const searchToggle = document.getElementById('search-toggle');
  const navSearch    = document.getElementById('nav-search');
  const searchInput  = navSearch ? navSearch.querySelector('.nav-search__input') : null;
  if (searchToggle && navSearch) {
    searchToggle.addEventListener('click', () => {
      const isOpen = navSearch.classList.toggle('open');
      searchToggle.setAttribute('aria-expanded', isOpen);
      if (isOpen && searchInput) searchInput.focus();
    });
    document.addEventListener('click', (e) => {
      if (!navSearch.contains(e.target) && navSearch.classList.contains('open')) {
        navSearch.classList.remove('open');
        searchToggle.setAttribute('aria-expanded', 'false');
      }
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && navSearch.classList.contains('open')) {
        navSearch.classList.remove('open');
        searchToggle.setAttribute('aria-expanded', 'false');
      }
    });
  }

  /* ---- POLICIES DROPDOWN ---- */
  const policiesToggle = document.getElementById('policies-toggle');
  const navPolicies    = document.getElementById('nav-policies');
  if (policiesToggle && navPolicies) {
    policiesToggle.addEventListener('click', () => {
      const isOpen = navPolicies.classList.toggle('open');
      policiesToggle.setAttribute('aria-expanded', isOpen);
    });
    document.addEventListener('click', (e) => {
      if (!navPolicies.contains(e.target) && navPolicies.classList.contains('open')) {
        navPolicies.classList.remove('open');
        policiesToggle.setAttribute('aria-expanded', 'false');
      }
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && navPolicies.classList.contains('open')) {
        navPolicies.classList.remove('open');
        policiesToggle.setAttribute('aria-expanded', 'false');
      }
    });
  }

  /* ---- TRUCK MODEL SELECTOR (Peterbilt dropdown etc.) ---- */
  document.querySelectorAll('[data-truck-toggle]').forEach(toggle => {
    const card = toggle.closest('.truck-card--has-models');
    if (!card) return;
    const menu = card.querySelector('.truck-card__models');

    toggle.addEventListener('click', (e) => {
      e.stopPropagation();
      // Close any other open truck menus
      document.querySelectorAll('.truck-card--has-models.open').forEach(other => {
        if (other !== card) {
          other.classList.remove('open');
          const otherToggle = other.querySelector('[data-truck-toggle]');
          const otherMenu = other.querySelector('.truck-card__models');
          if (otherToggle) otherToggle.setAttribute('aria-expanded', 'false');
          if (otherMenu) otherMenu.hidden = true;
        }
      });
      const isOpen = card.classList.toggle('open');
      toggle.setAttribute('aria-expanded', isOpen);
      if (menu) menu.hidden = !isOpen;
    });
  });

  // Close truck menus when clicking outside
  document.addEventListener('click', (e) => {
    if (!e.target.closest('.truck-card--has-models')) {
      document.querySelectorAll('.truck-card--has-models.open').forEach(card => {
        card.classList.remove('open');
        const toggle = card.querySelector('[data-truck-toggle]');
        const menu = card.querySelector('.truck-card__models');
        if (toggle) toggle.setAttribute('aria-expanded', 'false');
        if (menu) menu.hidden = true;
      });
    }
  });

  // Close on Escape
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      document.querySelectorAll('.truck-card--has-models.open').forEach(card => {
        card.classList.remove('open');
        const toggle = card.querySelector('[data-truck-toggle]');
        const menu = card.querySelector('.truck-card__models');
        if (toggle) toggle.setAttribute('aria-expanded', 'false');
        if (menu) menu.hidden = true;
      });
    }
  });

  /* ---- STICKY NAV on scroll ---- */
  const nav = document.getElementById('site-nav');
  if (nav) {
    window.addEventListener('scroll', () => {
      nav.style.background = window.scrollY > 80
        ? 'rgba(10,10,10,0.98)'
        : 'linear-gradient(to bottom, rgba(10,10,10,0.98) 0%, rgba(10,10,10,0) 100%)';
    }, { passive: true });
  }

  /* ---- CART DRAWER ---- */
  const cartDrawer  = document.getElementById('cart-drawer');
  const cartToggle  = document.getElementById('cart-toggle');
  const cartClose   = document.querySelector('.cart-drawer__close');
  const cartOverlay = document.querySelector('.cart-drawer__overlay');
  const cartCount   = document.getElementById('cart-count');
  const cartBody    = document.getElementById('cart-drawer-body');
  const cartSubtotal = document.getElementById('cart-subtotal');

  function openCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('open');
    cartDrawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closeCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('open');
    cartDrawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  if (cartToggle)  cartToggle.addEventListener('click', openCart);
  if (cartClose)   cartClose.addEventListener('click', closeCart);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function updateCartUI(cart) {
    if (cartCount)    cartCount.textContent = cart.item_count;
    if (cartSubtotal) cartSubtotal.textContent = formatMoney(cart.total_price);
    if (!cartBody)    return;

    if (cart.item_count === 0) {
      cartBody.innerHTML = `
        <div class="cart-empty">
          <p>Your cart is empty.</p>
          <a href="/collections/all" class="btn-primary">Shop All Parts</a>
        </div>`;
      return;
    }

    cartBody.innerHTML = cart.items.map(item => `
      <div class="cart-item" data-key="${item.key}">
        <div class="cart-item__image">
          ${item.image ? `<img src="${item.image}" alt="${item.title}" width="70" height="70">` : ''}
        </div>
        <div class="cart-item__info">
          <div class="cart-item__title">${item.product_title}</div>
          ${item.variant_title && item.variant_title !== 'Default Title'
            ? `<div class="cart-item__variant">${item.variant_title}</div>` : ''}
          <div class="cart-item__price">${formatMoney(item.price)}</div>
        </div>
        <div class="cart-item__qty">
          <button class="qty-btn" data-action="decrease" data-key="${item.key}" data-qty="${item.quantity}">−</button>
          <span>${item.quantity}</span>
          <button class="qty-btn" data-action="increase" data-key="${item.key}" data-qty="${item.quantity}">+</button>
        </div>
      </div>`
    ).join('');

    // Update checkout button
    const checkoutBtn = document.querySelector('.cart-drawer__footer .btn-primary');
    if (checkoutBtn) checkoutBtn.textContent = `Checkout — ${formatMoney(cart.total_price)}`;

    // Qty buttons
    cartBody.querySelectorAll('.qty-btn').forEach(btn => {
      btn.addEventListener('click', async () => {
        const key    = btn.dataset.key;
        const action = btn.dataset.action;
        const qty    = parseInt(btn.dataset.qty);
        const newQty = action === 'increase' ? qty + 1 : Math.max(0, qty - 1);
        await updateCartItem(key, newQty);
      });
    });
  }

  async function addToCart(variantId, quantity = 1, btn) {
    if (btn) { btn.disabled = true; btn.classList.add('loading'); }
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity })
      });
      if (!res.ok) throw new Error('Add to cart failed');
      const cart = await fetchCart();
      openCart();
      // Mark btn as "in cart"
      if (btn) setCardInCart(btn, variantId, cart);
    } catch (e) {
      console.error(e);
    } finally {
      if (btn) { btn.disabled = false; btn.classList.remove('loading'); }
    }
  }

  async function removeFromCart(variantId, btn) {
    if (btn) { btn.disabled = true; btn.classList.add('loading'); }
    try {
      const cartRes = await fetch('/cart.js');
      const cart    = await cartRes.json();
      const item    = cart.items.find(i => String(i.variant_id) === String(variantId));
      if (!item) return;

      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: item.key, quantity: 0 })
      });

      await fetchCart();
      if (btn) setCardNotInCart(btn, variantId);
    } catch (e) {
      console.error('Remove from cart error:', e);
    } finally {
      if (btn) { btn.disabled = false; btn.classList.remove('loading'); }
    }
  }

  function setCardInCart(btn, variantId, cart) {
    btn.classList.add('in-cart');
    btn.setAttribute('aria-label', 'Remove from cart');
    btn.innerHTML = `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="5" y1="12" x2="19" y2="12"/></svg>`;
    btn.onclick = (e) => { e.preventDefault(); removeFromCart(variantId, btn); };
  }

  function setCardNotInCart(btn, variantId) {
    btn.classList.remove('in-cart');
    btn.setAttribute('aria-label', 'Add to cart');
    btn.innerHTML = `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>`;
    btn.onclick = (e) => { e.preventDefault(); addToCart(variantId, 1, btn); };
  }

  async function fetchCart() {
    try {
      const res  = await fetch('/cart.js');
      const cart = await res.json();
      updateCartUI(cart);
      return cart;
    } catch (e) { console.error('Cart fetch error', e); }
  }

  async function updateCartItem(key, qty) {
    try {
      const res  = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      });
      const cart = await res.json();
      updateCartUI(cart);
      return cart;
    } catch (e) { console.error(e); }
  }

  /* Init quick-add buttons — check current cart state on load */
  async function initProductButtons() {
    const btns = document.querySelectorAll('.product-add[data-variant-id]');
    if (!btns.length) return;
    try {
      const res  = await fetch('/cart.js');
      const cart = await res.json();
      const inCartIds = new Set(cart.items.map(i => String(i.variant_id)));
      btns.forEach(btn => {
        const vid = btn.dataset.variantId;
        if (inCartIds.has(vid)) {
          setCardInCart(btn, vid, cart);
        } else {
          setCardNotInCart(btn, vid);
        }
      });
    } catch(e) {
      // Fallback: just set all to "+"
      btns.forEach(btn => setCardNotInCart(btn, btn.dataset.variantId));
    }
  }
  initProductButtons();

  /* Product page add-to-cart form + Add-ons support */
  const productForm = document.querySelector('form[action="/cart/add"]') ||
                      document.getElementById(`product-form-${document.querySelector('[data-product-id]')?.dataset.productId}`);
  const addCartBtn = document.getElementById('add-to-cart');

  // Helper: format money for the button
  function formatMoneyBtn(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function updateAddToCartTotal() {
    if (!addCartBtn) return;
    let total = parseInt(addCartBtn.dataset.basePrice || 0, 10);
    document.querySelectorAll('.addon-checkbox:checked').forEach(cb => {
      total += parseInt(cb.dataset.price || 0, 10);
    });
    if (total > 0) {
      addCartBtn.textContent = `Add to Cart — ${formatMoneyBtn(total)}`;
    }
  }
  // Expose so the variant selector in product-main can call it
  window.updateAddToCartTotal = updateAddToCartTotal;

  // Listen to checkbox changes
  document.querySelectorAll('.addon-checkbox').forEach(cb => {
    cb.addEventListener('change', updateAddToCartTotal);
  });

  if (productForm) {
    productForm.addEventListener('submit', async (e) => {
      e.preventDefault();
      const mainVariantId = document.getElementById('product-variant-id')?.value;
      if (!mainVariantId) return;

      // Collect selected add-ons
      const items = [{ id: parseInt(mainVariantId, 10), quantity: 1 }];
      document.querySelectorAll('.addon-checkbox:checked').forEach(cb => {
        items.push({ id: parseInt(cb.value, 10), quantity: 1 });
      });

      if (addCartBtn) {
        addCartBtn.disabled = true;
        addCartBtn.classList.add('loading');
      }

      try {
        // Shopify supports adding multiple items at once
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items })
        });
        if (!res.ok) {
          // Fallback: add one by one if bulk fails
          for (const item of items) {
            await fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify(item)
            });
          }
        }
        await fetchCart();
        openCart();
      } catch (err) {
        console.error('Add to cart with addons failed', err);
      } finally {
        if (addCartBtn) {
          addCartBtn.disabled = false;
          addCartBtn.classList.remove('loading');
        }
      }
    });
  }

  // Initial total (in case page loads with some checked – normally none)
  updateAddToCartTotal();

});
